class ValidationError extends Error {
  errors

  /**
   *
   * @param {Array<Object>} errors
   */
  constructor(errors) {
    super()

    this.errors = errors
  }

  /**
   *
   * @return {Array<Object>}
   */
  getErrors() {
    return this.errors
  }
}

export default ValidationError
